export default __webpack_public_path__ + "static/hero-gradient-bg-a71bef46cac74c527c74a3f79184c26f.png";